<template>
    <section class="content-section container-fluid px-3 pt-0">
        <h2 class="content-section-title center">{{info.title.toUpperCase()}}</h2>
        <div class="ad-container" :style="{ backgroundImage: info.bg}">
            <div  class="ad-inner">
                <b-container>
                    <b-row class="py-5">
                        <b-col lg="4" cols="12" v-for="(item,i) in info.items" :key="i" class="text-center p-3">
                            <b-img :src="item.img" class="mb-5" />
                            <p v-for="(v,i) in item.desc" :key="i">{{v}}</p>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: ["info"],
    data() {
        return {
            
        }
    },
}
</script>

<style lang="scss" scoped>
    .content-section:last-child {
        padding-bottom: 0 !important;
    }
    .ad-container {
        min-height: 300px;
        margin-left: -15px;
        margin-right: -15px;
        color: #fff;
        background-size: cover;
        background-repeat: no-repeat;
        background-attachment: fixed;

        img {
            max-width: 200px;
        }

        p:last-child {
            margin: 0
        }
    }
    .ad-inner {
        background-color: rgba(0, 0, 0, 0.56);
    }
</style>